/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import Lottie from 'react-lottie';

import animationData from './data.json';
import { useStyles } from './style';

export interface PreLoaderLogoProps {
    size: "small" | "medium";
}

export function PreLoaderLogo(props: PreLoaderLogoProps) {

    const classes = useStyles();
    const { size } = props;
    const loaderSize = (size === "small") ? "48px" : "64px";
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className={classes.preloaderWrapperLogo} id={"backdrop-loader"} >
            <Lottie options={defaultOptions} height={loaderSize} width={loaderSize} />
        </div>
    );
}
